import { render, staticRenderFns } from "./desglose_asig_docente.vue?vue&type=template&id=24e902a7"
import script from "./desglose_asig_docente.vue?vue&type=script&lang=js"
export * from "./desglose_asig_docente.vue?vue&type=script&lang=js"
import style0 from "./desglose_asig_docente.vue?vue&type=style&index=0&id=24e902a7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports